/**
 * Util functions.
 *
 * @type {Object}
 */

const Utils = {

	/**
	 * Function to get a cookie based on passed cookie name.
	 *
	 * @param {string} name Name of the cookie.
	 * @returns
	 */
	getCookie( name ) {

		let nameEQ = name + '=';

		let ca = document.cookie.split( ';' );

		for ( let i = 0; i < ca.length; i++ ) {
			let c = ca[i];
			while ( ' ' === c.charAt( 0 ) ) {
				c = c.substring( 1, c.length );
			}
			if ( 0 === c.indexOf( nameEQ ) ) {
				return c.substring( nameEQ.length, c.length );
			}
		}

		return null;

	},

	/**
	 * Create / Update a cookie based on given name value and expiration time.
	 *
	 * @param {string} name name of the cookie.
	 * @param {string} value value of the cookie.
	 * @param {number} days number of days to live before expiring.
	 */
	createCookie( name, value, days ) {
		let expires = '';
		if ( days ) {
			let date = new Date();
			date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
			expires = '; expires=' + date.toGMTString();
		}
		document.cookie = name + '=' + value + expires + '; path=/';
	},

	/**
	 * Delete cookie by name.
	 *
	 * @param {string} name name of the cookie.
	 */
	deleteCookie( name ) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	},

	/**
	 * Sanitize and encode data.
	 *
	 * @param {String} input
	 * @returns String
	 */
	sanitize( input ) {

		if ( 'undefined' === typeof input ) {
			return;
		}

		if ( ! input ) {
			return;
		}

		const map = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			'\'': '&#x27;',
			'/': '&#x2F;'
		};

		const regex = /[&<>"'/]/ig;

		return input.replace( regex, ( match )=>( map[match] ) );

	},

	/**
	 *  Validates if email is valid.
	 *
	 * @param {String} emailAddress Email address of the current user to validate.
	 * @returns String
	 */
	validateEmail ( emailAddress ) {

		if ( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( emailAddress ) ) {
			return true;
		}

		return false;

	},

	/**
	 * serialize the data.
	 *
	 * @param {*} data
	 * @returns
	 */
	serialize( data ) {
		return JSON.stringify( data );
	},

	/**
	 * Unserialize the data.
	 *
	 * @param {*} data
	 * @returns
	 */
	unSerialize( data ) {
		return JSON.parse( data );
	},

	/**
	 * Encrypt the data.
	 *
	 * @param {*} data
	 * @param {*} callback
	 * @param {*} async
	 * @returns
	 */
	encrypt( data, callback = ()=>{}, async = false ) {

		if ( 'undefined' === typeof data || ! data ) {
			return null;
		}

		let encrypted = null;

		if ( false === async ) {

			callback = ( response ) => {
				if ( 'undefined' !== typeof response ) {
					encrypted = response;
				}
			};

		}

		jQuery.ajax ( {
			url: SharedStorageOptions.ajaxurl,
			data: {
				'action': 'encrypt_data',
				'data': data,
				'nonce': SharedStorageOptions.nonce
			},
			type: 'POST',
			async: async,
			success: callback
		} );

		return encrypted;

	},

	/**
	 * Decrypt the data
	 *
	 * @param {*} data
	 * @param {*} callback
	 * @param {*} async
	 * @returns
	 */
	decrypt( data, callback = ()=>{}, async = false ) {

		if ( 'undefined' === typeof data || ! data ) {
			return null;
		}

		let decrypted = null;

		if ( false === async ) {

			callback = ( response ) => {
				if ( 'undefined' !== typeof response ) {
					decrypted = response;
				}
			};

		}

		jQuery.ajax ( {
			url: SharedStorageOptions.ajaxurl,
			data: {
				'action': 'decrypt_data',
				'data': data,
				'nonce': SharedStorageOptions.nonce
			},
			type: 'POST',
			async: async,
			success: callback
		} );

		return decrypted;

	},

	/**
	 * Asynchronously hashes an email address using the SHA-256 hashing algorithm.
	 *
	 * This function takes a string input (email address), encodes it into a Uint8Array using UTF-8 encoding,
	 * then hashes the encoded data using SHA-256. The hash is then converted to a hexadecimal string.
	 *
	 * @param {string} email - The email address to be hashed.
	 * @returns {Promise<string>} A promise that resolves with the hexadecimal string representation of the hashed email.
	 *
	*/
	async hashEmail( email ) {

		// Encode the email string into a Uint8Array.
		const encoder = new TextEncoder();
		const data = encoder.encode( email );

		// Hash the data with SHA-256.
		const hashBuffer = await crypto.subtle.digest( 'SHA-256', data );

		// Convert the buffer to a hex string.
		const hashArray = Array.from( new Uint8Array( hashBuffer ) );
		const hashHex = hashArray.map( byte => byte.toString( 16 ).padStart( 2, '0' ) ).join( '' );

		return hashHex;
	},

	/**
	 * Get gravity form field by label.
	 *
	 * @param {string} labelsWithComma
	 * @param {*} formElem
	 * @returns
	 */
	getGravityFormFieldByLabel( labelsWithComma, formElem ) {

		if ( ! labelsWithComma ) {
			return null;
		}

		// Make sure to exclude honeypot fields from autofilling.
		const elements = formElem.querySelectorAll( '.gfield:not(.gfield--type-honeypot) label' ) || [];
		const labels = labelsWithComma.toLowerCase().split( ',' ).map( ( label ) => label.trim() ) || [];

		for ( let element of elements ) {
			const fieldLabel = element.firstChild;

			if ( fieldLabel && 'nodeType' in fieldLabel && fieldLabel.nodeType === Node.TEXT_NODE && labels.includes( fieldLabel.data.toLowerCase() ) ) {
				return element.parentNode;
			}
		}
		
		return null;

	},

	getGravityFormFieldByClassName( className, formElem, single = true ) {

		if ( single ) {
			return formElem.querySelector( '.' + className );
		}

		return formElem.querySelectorAll( '.' + className );

	},

	/**
	 * Extract value from URL.
	 *
	 * @param {*} key
	 * @returns
	 */
	extractValueFromURL( key ) {
		let currentPage = window.location;
		let url = new URL( currentPage );

		let capturedValue = url.searchParams.get( key );
		if ( null !== capturedValue ) {
			return capturedValue;
		}

		return '';
	},

	/**
	 * Execute task in loop until callback function returns true.
	 *
	 * @param {*} callback
	 * @param {*} timeout Time out in milliseconds. Default is infinite.
	 */
	async waitUntil( callback, timeout = -1 ) {
		return new Promise( ( resolve ) => {
			const timeWas = new Date();
			const wait = setInterval( () => {

				if ( callback() ) {
					console.log( 'resolved after', new Date() - timeWas, 'ms' );
					clearInterval( wait );
					resolve();
				}

				if ( -1 !== timeout && new Date() - timeWas > timeout ) { // Timeout
					console.log( 'timeout', new Date() - timeWas, 'ms' );
					clearInterval( wait );
					resolve();
				}
			}, 20 );
		} );
	},

	localStorageSupported() {
		var storageSupported = false;

		try {
			storageSupported = ( window.localStorage && true );
		} catch ( e ) {}

		return storageSupported;
	},

	getGformFieldsKeyLabelTextFields() {
		const fieldsRaw = window.SharedStorageOptions ? window.SharedStorageOptions.fields : undefined;

		if ( ! fieldsRaw ) {
			return {
				firstname: 'First Name',
				lastname: 'Last Name',
				dealership: 'Dealership',
				phone: 'Phone',
				zipcode: 'Zip Code',
				financialinstitution: 'Financial Institution',
				dealershipname: 'Dealership Name',
				dealershipnames: 'Dealership Name(s)',
				zip: 'Zip',
				jobtitle: 'Job Title'
			};
		}

		return Object.values( fieldsRaw ).reduce( ( acc, curr ) => {
			acc[ curr.field ] = curr.labels;
			return acc;
		}, {} ) || {}; 
	},

	getGformFieldsKeyLabelDropDownFields() {

		return {
			state: 'State',
			title: 'Title',
			dealershiptype: 'Dealership Type',
			iminterestedin: 'I\'m interested in',
			country: 'Country'
		};
	},

	getGformFieldsKeyLabelByClassNameTextFields() {

		return {
			dealershiptype1: 'dealershipType1'
		};
	},

	/**
	 * Decode HTML Entities.
	 *
	 * @param {*} encoded Encoded String.
	 *
	 * @returns {string} Decoded String.
	 */
	decodeHTMLEntities( encoded ) {

		const parser = new DOMParser();
		let decoded = parser.parseFromString( `${ encoded }`, 'text/html' ).body.textContent;
		decoded = decodeURIComponent( decoded );
		return decoded;
	}

};

export default Utils;
